var map = {
	"./comodo-secure.png": 1242,
	"./flag-france.png": 1243,
	"./flag-germany.png": 1244,
	"./flag-italy.png": 1245,
	"./flag-netherlands.png": 1246,
	"./flag-portugal.png": 1247,
	"./flag-spain.png": 1248,
	"./flag-usa.png": 1249,
	"./global-cart-seal.png": 1250,
	"./icon-wanelo copy.png": 1251,
	"./icon-wanelo.png": 1252,
	"./icon-whatsapp copy.png": 1253,
	"./icon-whatsapp.png": 1254,
	"./lock.png": 1255,
	"./pagamento-cinza.png": 1256,
	"./pagamento-verde.png": 1257,
	"./pagamento-vermelho.png": 1258,
	"./payment-methods-br.png": 1259,
	"./payment-methods-global.png": 1260,
	"./payment-methods.png": 1261,
	"./pedido-cinza.png": 1262,
	"./pedido-verde.png": 1263,
	"./pedido-vermelho.png": 1264,
	"./selo-ebit-ouro.png": 1265,
	"./selo-eureciclo.png": 1266,
	"./selo-internet-segura.png": 1267,
	"./selo-ra1000.png": 1268,
	"./selo_100-seguro-retina.png": 306,
	"./selo_100-seguro.png": 1269,
	"./selo_site_seguro_certisign.png": 1270,
	"./selo_site_seguro_mcafee.png": 1271,
	"./selo_site_seguro_norton.png": 1272,
	"./selo_site_seguro_norton_small.png": 1273,
	"./separacao-cinza.png": 1274,
	"./separacao-verde.png": 1275,
	"./separacao-vermelho.png": 1276,
	"./shipping-methods-global.png": 1277,
	"./transporte-cinza.png": 1278,
	"./transporte-verde.png": 1279,
	"./transporte-vermelho.png": 1280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;